// AKSU Business School Official Portal Data
// Domain: businessschool.aksu.edu.ng
// British English throughout
import { 
  FACULTY_LECTURERS, 
  SEMESTER_COURSES, 
  getCourseByCode, 
  getCoursesByProgrammeId, 
  getCoursesByLecturerId,
  getFacultyById
} from './semesterCourseData';

export { 
  FACULTY_LECTURERS, 
  SEMESTER_COURSES, 
  getCourseByCode, 
  getCoursesByProgrammeId, 
  getCoursesByLecturerId,
  getFacultyById 
};

export const INSTITUTION_INFO = {
  name: "Akwa Ibom State University Business School",
  shortName: "AKSU Business School",
  acronym: "AIBS",
  parentUniversity: "Akwa Ibom State University",
  domain: "businessschool.aksu.edu.ng",
  officialUrl: "https://businessschool.aksu.edu.ng/admissions",
  studyUrl: "https://www.aksu.edu.ng/study",
  motto: "Knowledge · Enterprise · Leadership",
  universityMotto: "Knowledge & Technology for Development",
  established: "NUC-Accredited Professional & Executive Education Arm of Akwa Ibom State University",
  viceChancellor: "Prof. Nse Essien",
  director: {
    name: "Dr Uwem Etim Uwah",
    title: "Acting Director, AKSU Business School",
    qualifications: "PhD, FCA, ACTI",
    fellowship: "Fellow, Institute of Chartered Accountants of Nigeria (ICAN)",
    department: "Department of Accounting",
    email: "uwemuwah@aksu.edu.ng",
    phone: "08033380401",
    avatar: "/director-uwah.png",
    message: "On behalf of the management, faculty, and staff of the Akwa Ibom State University (AKSU) Business School, I am pleased to welcome you to a community dedicated to shaping principled, knowledgeable, and enterprising leaders for Nigeria's public and private sectors. Whether you are an accountant seeking professional advancement, a civil servant preparing for greater responsibility, a business executive sharpening your strategic edge, or a recent graduate beginning a postgraduate journey, AKSU Business School offers a pathway built on academic rigour, practical relevance, and professional recognition. We invite you to explore this prospectus and to take the next step toward a Certificate, Diploma, Postgraduate Diploma, Master's, or Doctorate qualification with us."
  },
  contacts: {
    generalEmail: "aisubs@aksu.edu.ng",
    directorEmail: "uwemuwah@aksu.edu.ng",
    phoneWhatsApp: "08033380401",
    phoneVoice: "07012550607",
    admissionsHelpline: "08033380401, 07012550607",
    website: "https://businessschool.aksu.edu.ng/admissions",
    studyPortal: "https://www.aksu.edu.ng/study",
    social: {
      linkedin: "https://www.linkedin.com/company/aksu-business-school",
      facebook: "https://www.facebook.com/aksu-business-school"
    },
    campuses: [
      {
        name: "Obio Akpa Campus (Official Business School Operating Campus)",
        address: "Obio Akpa Campus, Oruk Anam Local Government Area, P.M.B 1167, Uyo, Akwa Ibom State",
        focus: "Primary Academic Operating Campus, Executive Lectures, Seminar Theatres & ICT Facilities"
      },
      {
        name: "AKSU Business School Liaison Office",
        address: "6 Tony Asikpo Street, Shelter Afrique, P.M.B 1167, Uyo, Akwa Ibom State",
        focus: "Prospective Student Enquiries, Document Submission, Physical Registration Forms & Student Support"
      },
      {
        name: "Main Campus (University Headquarters)",
        address: "Ikot Akpaden, Mkpat Enin LGA, P.M.B 1167, Uyo, Akwa Ibom State",
        focus: "Akwa Ibom State University Central Administration, Senate & Research Laboratories"
      }
    ]
  },
  campusLocation: "Obio Akpa Campus, Oruk Anam LGA · Liaison Office: 6 Tony Asikpo Street, Shelter Afrique, Uyo",
  campuses: [
    {
      name: "Obio Akpa Campus (Business School Academic Operating Campus)",
      type: "Primary Academic & Operating Base",
      location: "Obio Akpa, Oruk Anam Local Government Area, P.M.B 1167, Uyo, Akwa Ibom State",
      description: "The official academic operating campus of AKSU Business School. Houses the executive lecture halls, digital ICT facilities, seminar amphitheatres, and academic departmental suites for physical and hybrid learning sessions.",
      features: [
        "Executive Lecture Theatres & Amphitheatres",
        "E-Learning Support Portal & ICT Facilities",
        "University Library Resources Access",
        "Interactive Seminar & Workshop Theatres",
        "High-Speed Internet & Digital Video Conferencing Hubs",
        "Uninterrupted Power for Executive Sessions"
      ]
    },
    {
      name: "AKSU Business School Liaison Office (Uyo)",
      type: "Liaison, Enquiries & Student Support Office",
      location: "6 Tony Asikpo Street, Shelter Afrique, P.M.B 1167, Uyo, Akwa Ibom State",
      description: "Dedicated executive Liaison Office situated in the state capital for prospective student enquiries, document submission, physical registration form submission with credentials, and student administrative support.",
      features: [
        "Walk-In Admissions & Programme Advisory",
        "Hardcopy Registration Form & Credentials Submission Desk",
        "Executive Student Administrative Support",
        "Document Processing & Direct Correspondence",
        "Admissions Dossier Verification Center"
      ]
    },
    {
      name: "Main Campus (University Headquarters)",
      type: "University Senate & Central Directorate",
      location: "Ikot Akpaden, Mkpat Enin LGA, P.M.B 1167, Uyo, Akwa Ibom State",
      description: "The central headquarters of Akwa Ibom State University, housing the University Senate, central research archives, and Governing Council.",
      features: [
        "University Senate & Vice Chancellor Chambers",
        "Central University E-Library Archives",
        "Statutory Accreditation Repository"
      ]
    }
  ],
  accreditations: [
    "Full Accreditation by National Universities Commission (NUC)",
    "Institute of Chartered Accountants of Nigeria (ICAN) Strategic Partnership",
    "Chartered Institute of Bankers of Nigeria (CIBN) Professional Alliance",
    "Nigerian Institute of Management (NIM - Chartered) Accredited Training Partner"
  ],
  academicYear: "2025/2026 Academic Session",
  session: "2025/2026",
  nextIntake: "October 2026 Commencement (Hybrid: Online & In-Person)",
  registrationDeadline: "On or before 30th September",
  applicationFee: 30000, // NGN 30,000 non-refundable registration fee at online registration
  acceptanceFee: 50000,  // Baseline acceptance fee
  acceptanceFees: {
    certificateDiploma: 50000, // NGN 50,000
    masters: 100000,           // NGN 100,000
    doctorate: 150000          // NGN 150,000
  },
  modeOfStudy: {
    title: "Hybrid (online and in-person)",
    components: [
      "Online and physical lectures",
      "Facilitations",
      "Seminars",
      "Workshops",
      "Video conferencing, etc."
    ]
  },
  paymentStructure: {
    fullPayment: "Paid once at the beginning of the academic session",
    installments: "Two instalments of 60:40 ratio (60% First Semester, 40% Second Semester)"
  },
  vision: "Akwa Ibom State University Business School is determined to be a premier centre of excellence in business education, research, and innovation, producing ethical leaders and entrepreneurs who drive sustainable development across Africa and beyond.",
  mission: "The mission is to deliver transformative business education rooted in global best practices and local relevance, foster impactful research, and cultivate entrepreneurial mindsets that empower individuals and communities."
};

export const WHO_SHOULD_APPLY = [
  "Accountants and finance professionals",
  "Civil and public servants",
  "Administrators and managers",
  "Captains of industry and business executives",
  "Political office holders",
  "Heads of Ministries, Departments and Agencies (MDAs)"
];

export const OFFICIAL_ADMISSION_REQUIREMENTS = {
  masters: {
    level: "Master's Degree (MBA, EMPA, EMAF)",
    requirement: "A good first degree (minimum of Second Class Lower or equivalent) from a recognised university.",
    duration: "Two years",
    tuitionPerSession: "NGN 1,000,000",
    acceptanceFee: "NGN 100,000"
  },
  doctorate: {
    level: "Doctorate (DBA, DPA, DAF)",
    requirement: "A Master's degree in a relevant discipline from a recognised university.",
    duration: "Three years",
    tuitionPerSession: "NGN 2,000,000",
    acceptanceFee: "NGN 150,000"
  },
  diplomaCertificate: {
    level: "Diploma & Certificate Programmes",
    requirement: "A minimum of five (5) SSCE credits (including English and Mathematics) in the discipline of choice, or equivalent professional/work experience, at the discretion of the Admissions Committee.",
    duration: "Certificate: Six months | Diploma & PGD: One year",
    tuitionPerSession: "NGN 500,000",
    acceptanceFee: "NGN 50,000"
  }
};

export const APPLICATION_PROCEDURE_STEPS = [
  {
    step: 1,
    title: "Visit the University's Admission Portal",
    description: "Visit https://businessschool.aksu.edu.ng/admissions (or www.aksu.edu.ng/study) to begin."
  },
  {
    step: 2,
    title: "Select Programme Type",
    description: "Click “APPLY FOR ADMISSION” and select your qualification level: Certificate, Diploma, PGD, Master's, or Doctorate/Ph.D."
  },
  {
    step: 3,
    title: "Pay Non-Refundable Registration Fee (₦30,000)",
    description: "Enter your email and basic details, and proceed to pay the non-refundable registration fee of ₦30,000 securely via online payment."
  },
  {
    step: 4,
    title: "Complete Online Application Form",
    description: "Fill in your bio-data, academic qualifications, professional profile, and upload certified copies of credentials."
  },
  {
    step: 5,
    title: "Print & Submit Form with Credentials to Liaison Office",
    description: "Print a copy of the completed registration form and submit it, along with your credentials, to the Director, AKSU Business School, at the AKSU Liaison Office, 6 Tony Asikpo Street, Shelter Afrique, P.M.B 1167, Uyo, Akwa Ibom State."
  }
];

export const DEPARTMENTS_AND_PROGRAMMES = [
  {
    id: "business-admin",
    name: "Business Administration",
    description: "Executive strategic management, entrepreneurial leadership, enterprise governance, and global commerce.",
    programmes: [
      {
        id: "dba",
        degree: "DBA",
        name: "Doctor of Business Administration (DBA)",
        duration: "Three years",
        mode: "Hybrid (Online & In-Person Modules)",
        feePerSession: "₦2,000,000",
        tuitionNumber: 2000000,
        acceptanceFee: "₦150,000",
        acceptanceFeeNumber: 150000,
        category: "Doctoral",
        description: "Prestigious doctoral qualification for C-suite executives, directors, permanent secretaries, and captains of industry focusing on applied organisational leadership, innovation, and enterprise governance.",
        requirements: "A Master's degree in a relevant discipline from a recognised university."
      },
      {
        id: "phd-ba",
        degree: "PhD",
        name: "Doctor of Philosophy in Business Administration",
        duration: "Three years",
        mode: "Hybrid (Research Seminars & Dissertation)",
        feePerSession: "₦2,000,000",
        tuitionNumber: 2000000,
        acceptanceFee: "₦150,000",
        acceptanceFeeNumber: 150000,
        category: "Doctoral",
        description: "Advanced research doctorate targeted at top researchers, policy advisers, and corporate strategists seeking frontier scholarship in strategic management.",
        requirements: "A Master's degree in a relevant discipline from a recognised university."
      },
      {
        id: "mba",
        degree: "MBA",
        name: "Master of Business Administration (MBA)",
        duration: "Two years",
        mode: "Hybrid (Online & In-Person Lectures, Facilitations & Workshops)",
        feePerSession: "₦1,000,000",
        tuitionNumber: 1000000,
        acceptanceFee: "₦100,000",
        acceptanceFeeNumber: 100000,
        category: "Master's",
        description: "Flagship executive master's degree building 360-degree leadership, financial acumen, strategic marketing, and corporate operational agility for advancing professionals.",
        requirements: "A good first degree (minimum of Second Class Lower or equivalent) from a recognised university."
      },
      {
        id: "pgd-ba",
        degree: "PGD",
        name: "Postgraduate Diploma in Business Administration (PGD)",
        duration: "One year",
        mode: "Hybrid (Weekend Modules & Online Seminars)",
        feePerSession: "₦500,000",
        tuitionNumber: 500000,
        acceptanceFee: "₦50,000",
        acceptanceFeeNumber: 50000,
        category: "Postgraduate Diploma",
        description: "Postgraduate diploma providing comprehensive foundation in corporate management, quantitative methods, and managerial economics for university graduates and HND holders.",
        requirements: "A recognised first degree, Higher National Diploma (HND), or equivalent qualification."
      },
      {
        id: "dip-ba",
        degree: "Diploma",
        name: "Diploma in Business Administration",
        duration: "One year",
        mode: "Hybrid (Online & Physical Lectures)",
        feePerSession: "₦500,000",
        tuitionNumber: 500000,
        acceptanceFee: "₦50,000",
        acceptanceFeeNumber: 50000,
        category: "Diploma",
        description: "One-year professional diploma developing core business competencies, operational management, bookkeeping, and customer service delivery.",
        requirements: "A minimum of five (5) SSCE credits (including English and Mathematics) in the discipline of choice, or equivalent professional/work experience."
      },
      {
        id: "cert-ba",
        degree: "Certificate",
        name: "Certificate in Business Administration",
        duration: "Six months",
        mode: "Hybrid (Interactive Masterclasses & Video Conferencing)",
        feePerSession: "₦500,000",
        tuitionNumber: 500000,
        acceptanceFee: "₦50,000",
        acceptanceFeeNumber: 50000,
        category: "Certificate",
        description: "Six-month professional certificate delivering fast-track executive skills for supervisors, business owners, and departmental managers.",
        requirements: "A minimum of five (5) SSCE credits (including English and Mathematics) in the discipline of choice, or equivalent professional/work experience."
      }
    ]
  },
  {
    id: "public-admin",
    name: "Public Administration",
    description: "Public policy analysis, strategic governance, MDA leadership, civil service reform, and administrative statecraft.",
    programmes: [
      {
        id: "dpa",
        degree: "DPA",
        name: "Doctor of Public Administration (DPA)",
        duration: "Three years",
        mode: "Hybrid (Policy Labs, Seminars & Executive Thesis)",
        feePerSession: "₦2,000,000",
        tuitionNumber: 2000000,
        acceptanceFee: "₦150,000",
        acceptanceFeeNumber: 150000,
        category: "Doctoral",
        description: "Terminal executive doctorate designed for senior civil servants, legislators, development partners, and public policy practitioners to interrogate administrative law and intergovernmental relations.",
        requirements: "A Master's degree in a relevant discipline from a recognised university."
      },
      {
        id: "empa",
        degree: "EMPA",
        name: "Executive Master of Public Administration (EMPA)",
        duration: "Two years",
        mode: "Hybrid (Online & Physical Lectures, Policy Workshops)",
        feePerSession: "₦1,000,000",
        tuitionNumber: 1000000,
        acceptanceFee: "₦100,000",
        acceptanceFeeNumber: 100000,
        category: "Master's",
        description: "Specialised executive master's focused on public sector budgeting, e-governance, policy design, government procurement, and ethical public administration.",
        requirements: "A good first degree (minimum of Second Class Lower or equivalent) from a recognised university."
      },
      {
        id: "p-dip-pa",
        degree: "Professional Diploma",
        name: "Professional Diploma in Public Administration",
        duration: "One year",
        mode: "Hybrid (Facilitations & In-Person Seminars)",
        feePerSession: "₦500,000",
        tuitionNumber: 500000,
        acceptanceFee: "₦50,000",
        acceptanceFeeNumber: 50000,
        category: "Diploma",
        description: "One-year professional diploma covering civil service regulations, administrative jurisprudence, public records management, and personnel administration.",
        requirements: "A minimum of five (5) SSCE credits (including English and Mathematics) in the discipline of choice, or equivalent professional/work experience."
      },
      {
        id: "p-cert-pa",
        degree: "Professional Certificate",
        name: "Professional Certificate in Public Administration",
        duration: "Six months",
        mode: "Hybrid (Workshops & Digital Conferencing)",
        feePerSession: "₦500,000",
        tuitionNumber: 500000,
        acceptanceFee: "₦50,000",
        acceptanceFeeNumber: 50000,
        category: "Certificate",
        description: "Six-month certificate imparting essential skills in administrative drafting, official records keeping, ethics in governance, and civil service correspondence.",
        requirements: "A minimum of five (5) SSCE credits (including English and Mathematics) in the discipline of choice, or equivalent professional/work experience."
      }
    ]
  },
  {
    id: "accounting-finance",
    name: "Accounting and Finance",
    description: "Corporate financial engineering, forensic accounting, auditing standards, taxation policy, and capital markets.",
    programmes: [
      {
        id: "daf",
        degree: "DAF",
        name: "Doctor of Accounting and Finance (DAF)",
        duration: "Three years",
        mode: "Hybrid (Financial Econometrics & Executive Research)",
        feePerSession: "₦2,000,000",
        tuitionNumber: 2000000,
        acceptanceFee: "₦150,000",
        acceptanceFeeNumber: 150000,
        category: "Doctoral",
        description: "Premier doctoral programme investigating corporate financial structure, forensic accounting, capital markets, international taxation, and corporate governance.",
        requirements: "A Master's degree in a relevant discipline from a recognised university."
      },
      {
        id: "phd-af",
        degree: "Doctorate",
        name: "Doctor of Accounting and Finance",
        duration: "Three years",
        mode: "Hybrid (Advanced Financial Econometrics & Research)",
        feePerSession: "₦2,000,000",
        tuitionNumber: 2000000,
        acceptanceFee: "₦150,000",
        acceptanceFeeNumber: 150000,
        category: "Doctoral",
        description: "Premier doctoral programme investigating contemporary financial market dynamics, international taxation, and corporate disclosure.",
        requirements: "A Master's degree in a relevant discipline from a recognised university."
      },
      {
        id: "emaf",
        degree: "EMAF",
        name: "Executive Master of Accounting and Finance (EMAF)",
        duration: "Two years",
        mode: "Hybrid (Online & Physical Lectures, Financial Modeling)",
        feePerSession: "₦1,000,000",
        tuitionNumber: 1000000,
        acceptanceFee: "₦100,000",
        acceptanceFeeNumber: 100000,
        category: "Master's",
        description: "Designed in alignment with ICAN and CITN standards for Chief Financial Officers, audit managers, treasurers, and investment bankers.",
        requirements: "A good first degree (minimum of Second Class Lower or equivalent) from a recognised university."
      },
      {
        id: "p-dip-af",
        degree: "Professional Diploma",
        name: "Professional Diploma in Accounting and Finance",
        duration: "One year",
        mode: "Hybrid (Practical Labs & In-Person Seminars)",
        feePerSession: "₦500,000",
        tuitionNumber: 500000,
        acceptanceFee: "₦50,000",
        acceptanceFeeNumber: 50000,
        category: "Diploma",
        description: "One-year professional diploma covering financial reporting standards (IFRS), computerized accounting software, tax management, and auditing principles.",
        requirements: "A minimum of five (5) SSCE credits (including English and Mathematics) in the discipline of choice, or equivalent professional/work experience."
      },
      {
        id: "p-cert-af",
        degree: "Professional Certificate",
        name: "Professional Certificate in Accounting and Finance",
        duration: "Six months",
        mode: "Hybrid (Modular Labs & Workshops)",
        feePerSession: "₦500,000",
        tuitionNumber: 500000,
        acceptanceFee: "₦50,000",
        acceptanceFeeNumber: 50000,
        category: "Certificate",
        description: "Six-month certificate providing practical grounding in bookkeeping, payroll computation, treasury management, and audit inspection essentials.",
        requirements: "A minimum of five (5) SSCE credits (including English and Mathematics) in the discipline of choice, or equivalent professional/work experience."
      }
    ]
  }
];

// 4 DEMO STUDENTS (PhD, DBA, MBA, PGD) - ALL ASSUMED TO JUST START THEIR PROGRAMMES (TERM 1 / FRESH INTAKE)
// DBA incorporates the exact curriculum matrix from the institutional plan:
// T1: DBA 801 (3 Credits), T2: DBA 802 (6 Credits), T3: DBA 803 (6 Credits), T6: DBA 804 (3 Credits), T7: DBA 899 (36 Credits) = 54 Credits Total
export const DEMO_STUDENTS = [
  // 1. DOCTOR OF BUSINESS ADMINISTRATION (DBA)
  {
    id: "student-dba",
    programmeId: "dba",
    programmeName: "Doctor of Business Administration (DBA)",
    degreeLevel: "Doctorate",
    department: "Business Administration",
    fullName: "Emem Udoh",
    title: "Mr",
    gender: "Male",
    matricNo: "AKSU/BS/2026/DBA/012",
    email: "e.udoh@student.aksu.edu.ng",
    avatar: "https://images.unsplash.com/photo-1506277886164-e25aa3f4ef7f?q=80&w=300&auto=format&fit=crop",
    supervisor: "Prof. Anietie Akpan, PhD",
    advisor: "Dr. Imoh Uford, PhD",
    researchTopic: "Enterprise Artificial Intelligence and Dynamic Capabilities in Downstream Petroleum Supply Chains: An Akwa Ibom Corridor Case Study",
    researchStage: "Stage 1: Doctoral Problem Conceptualisation & AI Empirical Design",
    currentTerm: "First Semester (T1), 2026/2027 Session",
    status: "Newly Matriculated • First Semester Commencing",
    cgpa: "Not Computed (First Semester)",
    attendanceRate: 100,
    completedCredits: 0,
    enrolledCredits: 15,
    totalCredits: 54,
    overallProgress: 6,
    curriculumPlan: [
      {
        unit: "T1",
        slot: "Course 1",
        code: "BUS 901",
        course: "BUS 901: Data Science and Artificial intelligence",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 20,
        lecturer: "Dr. Imoh Uford",
        schedule: "Saturdays 09:00 - 12:00 (Amphitheatre A & Virtual Studio)"
      },
      {
        unit: "T1",
        slot: "Course 2",
        code: "BUS 911",
        course: "BUS 911: Adv. Quant. Analysis & Econometrics",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 15,
        lecturer: "Dr Ekere Daniel",
        schedule: "Saturdays 12:30 - 15:30 (Econometric Lab)"
      },
      {
        unit: "T1",
        slot: "Course 3",
        code: "BUS 921",
        course: "BUS 921: Adv. Business Mgmt Theory",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 15,
        lecturer: "Prof. Christabel Brownson",
        schedule: "Fridays 16:00 - 19:00 (Boardroom Suite)"
      },
      {
        unit: "T1",
        slot: "Course 4",
        code: "BUS 931",
        course: "BUS 931: Competitive Strategy",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 10,
        lecturer: "Prof. Anietie Akpan",
        schedule: "Saturdays 15:30 - 18:30 (Amphitheatre B)"
      },
      {
        unit: "T1",
        slot: "Course 5",
        code: "BUS 941",
        course: "BUS 941: Business writing, publication & research",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 10,
        lecturer: "Dr (Mrs) Eno Ukpong (Ass.Prof)",
        schedule: "Thursdays 15:00 - 18:00 (Doctoral Writing Studio)"
      }
    ],
    activeModule: {
      code: "BUS 901",
      title: "Data Science and Artificial intelligence",
      units: 3,
      lecturer: "Dr. Imoh Uford",
      coLecturer: "Dr. Ekere Daniel",
      progress: 20,
      grade: "Continuous Assessment Active",
      status: "In Progress (Week 2 of 12)",
      schedule: "Saturdays 09:00 - 12:00 (Amphitheatre A & Simultaneous Virtual Studio)",
      materialsCount: 5,
      overview: "Advanced doctoral exploration of enterprise data engineering, machine learning architectures, generative artificial intelligence, and predictive modeling for C-suite business strategy. Focuses on transforming high-dimensional corporate data into actionable competitive advantage in emerging markets.",
      lessons: [
        {
          id: "bus901-les-1",
          number: "Lesson 1",
          title: "Foundations of Big Data, Cloud Infrastructure & Business Intelligence",
          duration: "55 mins",
          status: "Completed",
          completed: true,
          videoTimestamp: 0,
          keyTakeaway: "Understanding data warehousing, ETL pipelines, and high-velocity analytics in corporate strategy.",
          facilitator: FACULTY_LECTURERS.find(f => f.id === "fac-uford")
        },
        {
          id: "bus901-les-2",
          number: "Lesson 2",
          title: "Supervised and Unsupervised Machine Learning for Executive Decision-Making",
          duration: "65 mins",
          status: "In Progress",
          completed: false,
          current: true,
          videoTimestamp: 20,
          keyTakeaway: "Formulating clustering, classification, and customer lifetime value algorithms without coding bottlenecks.",
          facilitator: FACULTY_LECTURERS.find(f => f.id === "fac-uford")
        },
        {
          id: "bus901-les-3",
          number: "Lesson 3",
          title: "Generative AI, Large Language Models (LLMs) & Corporate Knowledge Bases",
          duration: "50 mins",
          status: "Upcoming",
          completed: false,
          videoTimestamp: 45,
          keyTakeaway: "Retrieval-Augmented Generation (RAG) frameworks for enterprise policy querying and automated intelligence.",
          facilitator: FACULTY_LECTURERS.find(f => f.id === "fac-uford")
        },
        {
          id: "bus901-les-4",
          number: "Lesson 4",
          title: "AI Ethics, Algorithmic Bias, NDPR/GDPR Compliance & Board Oversight",
          duration: "45 mins",
          status: "Upcoming",
          completed: false,
          videoTimestamp: 70,
          keyTakeaway: "Institutional data protection frameworks and liability mitigation for senior directors.",
          facilitator: FACULTY_LECTURERS.find(f => f.id === "fac-uford")
        },
        {
          id: "bus901-les-5",
          number: "Lesson 5",
          title: "Doctoral Research Design: Incorporating Data Science into Business Inquiries",
          duration: "60 mins",
          status: "Upcoming",
          completed: false,
          videoTimestamp: 95,
          keyTakeaway: "Constructing empirical quantitative frameworks bridging computational models with management theory.",
          facilitator: FACULTY_LECTURERS.find(f => f.id === "fac-uford")
        }
      ],
      materials: [
        {
          title: "BUS 901 Course Syllabus & Executive AI Architecture Reader",
          type: "Syllabus",
          size: "3.8 MB",
          category: "Course Reader"
        },
        {
          title: "Executive Slide Deck: Machine Learning Paradigms for C-Suite Leaders",
          type: "Slide Deck",
          size: "8.2 MB",
          category: "Lecture Slides"
        },
        {
          title: "Harvard / Industry Case: Predictive Analytics in Downstream Energy Logistics",
          type: "Case Packet",
          size: "2.4 MB",
          category: "Case Study"
        },
        {
          title: "Empirical Dataset: Nigerian Industrial Supply Chain Disruptions (2020-2026)",
          type: "Excel Dataset",
          size: "14.5 MB",
          category: "Quantitative Data"
        }
      ],
      assignments: [
        {
          id: "asg-bus901-1",
          title: "Continuous Assessment 1: Enterprise AI Strategy & Governance Blueprint",
          brief: "Select a real-world enterprise in Nigeria or West Africa. Formulate a 10-page C-suite proposal detailing the deployment of a predictive machine learning solution to address an operational bottleneck, incorporating data governance, compliance with NDPR, and risk mitigation.",
          dueDate: "31st October 2026",
          status: "Drafting (In Progress)",
          weight: "30% Continuous Assessment",
          submitted: false
        }
      ]
    },
    modules: [
      {
        code: "BUS 901",
        title: "Data Science and Artificial intelligence",
        units: 3,
        lecturer: "Dr. Imoh Uford",
        progress: 20,
        grade: "In Progress",
        status: "In Progress",
        schedule: "Saturdays 09:00 - 12:00 (Amphitheatre A)",
        materialsCount: 5,
        assignments: [
          { title: "Enterprise AI Strategy & Governance Blueprint", status: "Due 31 Oct", score: "Pending" }
        ],
        overview: "Enterprise data engineering, machine learning architectures, generative AI, and predictive modeling for C-suite business strategy."
      },
      {
        code: "BUS 911",
        title: "Adv. Quant. Analysis & Econometrics",
        units: 3,
        lecturer: "Dr Ekere Daniel",
        progress: 15,
        grade: "In Progress",
        status: "In Progress",
        schedule: "Saturdays 12:30 - 15:30 (Econometric Lab)",
        materialsCount: 4,
        assignments: [
          { title: "Empirical Econometric Diagnostic Paper", status: "Due 5 Nov", score: "Pending" }
        ],
        overview: "Multivariate linear regression, simultaneous equations, dynamic panel data estimations, Structural Equation Modeling (PLS-SEM), and time-series cointegration."
      },
      {
        code: "BUS 921",
        title: "Adv. Business Mgmt Theory",
        units: 3,
        lecturer: "Prof. Christabel Brownson",
        progress: 15,
        grade: "In Progress",
        status: "In Progress",
        schedule: "Fridays 16:00 - 19:00 (Boardroom Suite)",
        materialsCount: 4,
        assignments: [
          { title: "Theoretical Synthesis Matrix", status: "Due 10 Nov", score: "Pending" }
        ],
        overview: "Critical examination of classical, contemporary, and emerging theories of business enterprise. Covers dynamic capabilities, RBV, and institutional theory."
      },
      {
        code: "BUS 931",
        title: "Competitive Strategy",
        units: 3,
        lecturer: "Prof. Anietie Akpan",
        progress: 10,
        grade: "In Progress",
        status: "In Progress",
        schedule: "Saturdays 15:30 - 18:30 (Amphitheatre B)",
        materialsCount: 4,
        assignments: [
          { title: "Strategic Blue Ocean Canvas Formulation", status: "Due 14 Nov", score: "Pending" }
        ],
        overview: "Formulation and execution of high-stakes corporate strategies, industry structural analysis (Porter's Five Forces), and Blue Ocean value innovation."
      },
      {
        code: "BUS 941",
        title: "Business writing, publication & research",
        units: 3,
        lecturer: "Dr (Mrs) Eno Ukpong (Ass.Prof)",
        progress: 10,
        grade: "In Progress",
        status: "In Progress",
        schedule: "Thursdays 15:00 - 18:00 (Doctoral Writing Studio)",
        materialsCount: 4,
        assignments: [
          { title: "Targeted Journal Manuscript Draft", status: "Due 18 Nov", score: "Pending" }
        ],
        overview: "Scholarly business communication, executive whitepapers, high-impact journal publishing (ABS 3*/4*), academic integrity, and research grant structuring."
      }
    ]
  },


  // 1b. DOCTOR OF BUSINESS ADMINISTRATION (DBA) - CANDIDATE 2
  {
    id: "student-dba-2",
    programmeId: "dba",
    programmeName: "Doctor of Business Administration (DBA)",
    degreeLevel: "Doctorate",
    department: "Business Administration",
    fullName: "Obong Victor Okon",
    title: "Mr",
    gender: "Male",
    matricNo: "AKSU/BS/2026/DBA/015",
    email: "victor.okon@student.aksu.edu.ng",
    avatar: "https://images.unsplash.com/photo-1621972660173-bb6dab9bd598?q=80&w=300&auto=format&fit=crop",
    supervisor: "Prof. Anietie Akpan, PhD",
    advisor: "Dr. Imoh Uford, PhD",
    researchTopic: "Competitive Dynamics and Dynamic Capabilities in Maritime Port Infrastructure: A Comparative Study of South-South Nigeria",
    researchStage: "Stage 1: Doctoral Problem Conceptualisation & Port Logistics Design",
    currentTerm: "First Semester (T1), 2026/2027 Session",
    status: "Newly Matriculated • First Semester Commencing",
    cgpa: "Not Computed (First Semester)",
    attendanceRate: 96,
    completedCredits: 0,
    enrolledCredits: 15,
    totalCredits: 54,
    overallProgress: 6,
    curriculumPlan: [
      {
        unit: "T1",
        slot: "Course 1",
        code: "BUS 901",
        course: "BUS 901: Data Science and Artificial intelligence",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 25,
        lecturer: "Dr. Imoh Uford",
        schedule: "Saturdays 09:00 - 12:00 (Amphitheatre A & Virtual Studio)"
      },
      {
        unit: "T1",
        slot: "Course 2",
        code: "BUS 911",
        course: "BUS 911: Adv. Quant. Analysis & Econometrics",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 20,
        lecturer: "Dr Ekere Daniel",
        schedule: "Saturdays 12:30 - 15:30 (Econometric Lab)"
      },
      {
        unit: "T1",
        slot: "Course 3",
        code: "BUS 921",
        course: "BUS 921: Adv. Business Mgmt Theory",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 15,
        lecturer: "Prof. Christabel Brownson",
        schedule: "Fridays 16:00 - 19:00 (Boardroom Suite)"
      },
      {
        unit: "T1",
        slot: "Course 4",
        code: "BUS 931",
        course: "BUS 931: Competitive Strategy",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 20,
        lecturer: "Prof. Anietie Akpan",
        schedule: "Saturdays 15:30 - 18:30 (Amphitheatre B)"
      },
      {
        unit: "T1",
        slot: "Course 5",
        code: "BUS 941",
        course: "BUS 941: Business writing, publication & research",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 10,
        lecturer: "Dr (Mrs) Eno Ukpong (Ass.Prof)",
        schedule: "Thursdays 15:00 - 18:00 (Doctoral Writing Studio)"
      }
    ],
    activeModule: {
      code: "BUS 931",
      title: "Competitive Strategy",
      units: 3,
      lecturer: "Prof. Anietie Akpan",
      progress: 20,
      grade: "Continuous Assessment Active",
      status: "In Progress (Week 2 of 12)",
      schedule: "Saturdays 15:30 - 18:30 (Amphitheatre B & Virtual Studio)",
      materialsCount: 4,
      overview: "Advanced doctoral exploration of corporate competitive advantage, Porterian frameworks, value net architectures, and maritime logistics strategies in emerging corridors.",
      lessons: [
        {
          id: "bus931-les-1",
          number: "Lesson 1",
          title: "Structural Analysis of Industries & Strategic Group Dynamics",
          duration: "60 mins",
          status: "Completed",
          completed: true,
          videoTimestamp: 0,
          keyTakeaway: "Five Forces mapping and barrier height determination in maritime logistics.",
          facilitator: FACULTY_LECTURERS.find(f => f.id === "fac-akpan")
        },
        {
          id: "bus931-les-2",
          number: "Lesson 2",
          title: "Dynamic Capabilities, Sensing and Seizing in High-Stakes Environments",
          duration: "55 mins",
          status: "In Progress",
          completed: false,
          current: true,
          videoTimestamp: 20,
          keyTakeaway: "Teece's dynamic capabilities applied to port automation and trade corridors.",
          facilitator: FACULTY_LECTURERS.find(f => f.id === "fac-akpan")
        }
      ],
      materials: [
        {
          title: "BUS 931 Competitive Strategy Syllabus & Executive Reading Dossier",
          type: "Syllabus",
          size: "4.1 MB",
          category: "Course Reader"
        },
        {
          title: "Maritime Port Strategy & Global Supply Chain Hub Dynamics Slide Deck",
          type: "Slide Deck",
          size: "9.3 MB",
          category: "Lecture Slides"
        }
      ],
      assignments: [
        {
          id: "asg-bus931-1",
          title: "Strategic Industry Analysis & Competitive Positioning Paper",
          brief: "Evaluate the competitive architecture of maritime logistics and downstream deep-sea terminals across South-South Nigeria.",
          dueDate: "4th November 2026",
          status: "Drafting",
          weight: "30% Continuous Assessment",
          submitted: false
        }
      ]
    },
    modules: [
      { code: "BUS 901", title: "Data Science and Artificial intelligence", units: 3, lecturer: "Dr. Imoh Uford", progress: 25, grade: "In Progress", status: "In Progress", schedule: "Saturdays 09:00 - 12:00", materialsCount: 5, assignments: [], overview: "AI strategy and data engineering." },
      { code: "BUS 911", title: "Adv. Quant. Analysis & Econometrics", units: 3, lecturer: "Dr Ekere Daniel", progress: 20, grade: "In Progress", status: "In Progress", schedule: "Saturdays 12:30 - 15:30", materialsCount: 4, assignments: [], overview: "Dynamic panel data and econometrics." },
      { code: "BUS 921", title: "Adv. Business Mgmt Theory", units: 3, lecturer: "Prof. Christabel Brownson", progress: 15, grade: "In Progress", status: "In Progress", schedule: "Fridays 16:00 - 19:00", materialsCount: 4, assignments: [], overview: "Advanced management epistemology." },
      { code: "BUS 931", title: "Competitive Strategy", units: 3, lecturer: "Prof. Anietie Akpan", progress: 20, grade: "In Progress", status: "In Progress", schedule: "Saturdays 15:30 - 18:30", materialsCount: 4, assignments: [], overview: "Corporate competitive strategies and value innovation." },
      { code: "BUS 941", title: "Business writing, publication & research", units: 3, lecturer: "Dr (Mrs) Eno Ukpong (Ass.Prof)", progress: 10, grade: "In Progress", status: "In Progress", schedule: "Thursdays 15:00 - 18:00", materialsCount: 4, assignments: [], overview: "Executive research publication." }
    ]
  },
  // 2. MASTER OF ACCOUNTING AND FINANCE (MAF)
  {
    id: "student-maf",
    programmeId: "maf",
    programmeName: "Master of Accounting and Finance (MAF)",
    degreeLevel: "Master's",
    department: "Accounting & Finance",
    fullName: "Bassey Edet",
    title: "Mr",
    gender: "Male",
    matricNo: "AKSU/BS/2026/MAF/018",
    email: "b.edet@student.aksu.edu.ng",
    avatar: "https://images.unsplash.com/photo-1531384441138-2736e62e0919?q=80&w=300&auto=format&fit=crop",
    supervisor: "Prof. Anthonia Ubom, PhD",
    advisor: "Dr. Mbobo Mbobo, PhD, FCA",
    researchTopic: "Evaluating the Impact of IFRS 9 Expected Credit Loss Provisioning on Commercial Bank Profitability in Nigeria",
    researchStage: "Term 1 Coursework & Methodological Formulation",
    currentTerm: "First Semester (T1), 2026/2027 Session",
    status: "Newly Matriculated • First Semester Commencing",
    cgpa: "Not Computed (First Semester)",
    attendanceRate: 100,
    completedCredits: 0,
    enrolledCredits: 15,
    totalCredits: 36,
    overallProgress: 5,
    curriculumPlan: [
      {
        unit: "T1",
        slot: "Course 1",
        code: "MAF 801",
        course: "MAF 801: Bus. Stats & Data Analytics",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 20,
        lecturer: "Dr Imoh Uford",
        schedule: "Saturdays 08:30 - 11:30 (Amphitheatre C)"
      },
      {
        unit: "T1",
        slot: "Course 2",
        code: "ACC 801",
        course: "ACC 801: Fin.Reporting under IFRS",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 15,
        lecturer: "Dr Mbobo Mbobo",
        schedule: "Saturdays 12:00 - 15:00 (Amphitheatre A)"
      },
      {
        unit: "T1",
        slot: "Course 3",
        code: "FIN 811",
        course: "FIN 811: Corp. Finance & Valuation",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 15,
        lecturer: "Prof. Anthonia Ubom",
        schedule: "Saturdays 15:30 - 18:30 (Amphitheatre A)"
      },
      {
        unit: "T1",
        slot: "Course 4",
        code: "ACC 811",
        course: "ACC 811: Mgmt Accounting & Control",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 10,
        lecturer: "Dr S A Okpo",
        schedule: "Fridays 16:00 - 19:00 (Amphitheatre C)"
      },
      {
        unit: "T1",
        slot: "Course 5",
        code: "MAF 811",
        course: "MAF 811: Research Methodology",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 10,
        lecturer: "Dr Udeme Eshiet",
        schedule: "Thursdays 15:30 - 18:30 (Amphitheatre B)"
      }
    ],
    activeModule: {
      code: "MAF 801",
      title: "Bus. Stats & Data Analytics",
      units: 3,
      lecturer: "Dr Imoh Uford",
      coLecturer: "Dr. Mbobo Mbobo",
      progress: 20,
      grade: "Continuous Assessment Active",
      status: "In Progress (Week 2 of 12)",
      schedule: "Saturdays 08:30 - 11:30 (Amphitheatre C & Virtual Studio)",
      materialsCount: 4,
      overview: "Statistical techniques for financial decision-making. Probability distributions, hypothesis testing, ANOVA, linear and multiple regression, time-series forecasting, and Python/Excel analytics for financial risk evaluation.",
      lessons: [
        {
          id: "maf801-les-1",
          number: "Lesson 1",
          title: "Descriptive Financial Statistics & Probability Distributions",
          duration: "50 mins",
          status: "Completed",
          completed: true,
          videoTimestamp: 0,
          keyTakeaway: "Normal, log-normal distributions and standard deviation in stock market volatility.",
          facilitator: FACULTY_LECTURERS.find(f => f.id === "fac-uford")
        },
        {
          id: "maf801-les-2",
          number: "Lesson 2",
          title: "Hypothesis Testing & Statistical Inference for Financial Decisions",
          duration: "55 mins",
          status: "In Progress",
          completed: false,
          current: true,
          videoTimestamp: 20,
          keyTakeaway: "One-sample and two-sample t-tests in evaluating abnormal investment returns.",
          facilitator: FACULTY_LECTURERS.find(f => f.id === "fac-uford")
        },
        {
          id: "maf801-les-3",
          number: "Lesson 3",
          title: "Multiple Regression Analytics & Ordinary Least Squares",
          duration: "60 mins",
          status: "Upcoming",
          completed: false,
          videoTimestamp: 45,
          keyTakeaway: "Estimating beta and financial asset sensitivity parameters.",
          facilitator: FACULTY_LECTURERS.find(f => f.id === "fac-uford")
        }
      ],
      materials: [
        {
          title: "MAF 801 Financial Statistics Study Pack & Formula Reference",
          type: "Study Pack",
          size: "3.9 MB",
          category: "Course Material"
        },
        {
          title: "Practical Financial Analytics Model in Excel",
          type: "Excel Model",
          size: "4.8 MB",
          category: "Quantitative Model"
        }
      ],
      assignments: [
        {
          id: "asg-maf801-1",
          title: "Financial Regression Analysis Project",
          brief: "Analyze the relationship between dividend payout ratio, leverage, and firm valuation for 20 quoted Nigerian manufacturing companies.",
          dueDate: "2nd November 2026",
          status: "Drafting",
          weight: "30% Continuous Assessment",
          submitted: false
        }
      ]
    },
    modules: [
      {
        code: "MAF 801",
        title: "Bus. Stats & Data Analytics",
        units: 3,
        lecturer: "Dr Imoh Uford",
        progress: 20,
        grade: "In Progress",
        status: "In Progress",
        schedule: "Saturdays 08:30 - 11:30 (Amphitheatre C)",
        materialsCount: 4,
        assignments: [
          { title: "Financial Regression Analysis Project", status: "Due 2 Nov", score: "Pending" }
        ],
        overview: "Statistical techniques for financial decision-making, hypothesis testing, and regression modeling."
      },
      {
        code: "ACC 801",
        title: "Fin.Reporting under IFRS",
        units: 3,
        lecturer: "Dr Mbobo Mbobo",
        progress: 15,
        grade: "In Progress",
        status: "In Progress",
        schedule: "Saturdays 12:00 - 15:00 (Amphitheatre A)",
        materialsCount: 4,
        assignments: [
          { title: "IFRS 16 Lease Impact Diagnostic Case", status: "Due 8 Nov", score: "Pending" }
        ],
        overview: "International Financial Reporting Standards (IFRS 9, 15, 16), fair value accounting, and group consolidated reporting."
      },
      {
        code: "FIN 811",
        title: "Corp. Finance & Valuation",
        units: 3,
        lecturer: "Prof. Anthonia Ubom",
        progress: 15,
        grade: "In Progress",
        status: "In Progress",
        schedule: "Saturdays 15:30 - 18:30 (Amphitheatre A)",
        materialsCount: 4,
        assignments: [
          { title: "Comprehensive Corporate Valuation Paper", status: "Due 12 Nov", score: "Pending" }
        ],
        overview: "Corporate capital structure, WACC calculation, DCF valuation, real options, and cross-border M&A."
      },
      {
        code: "ACC 811",
        title: "Mgmt Accounting & Control",
        units: 3,
        lecturer: "Dr S A Okpo",
        progress: 10,
        grade: "In Progress",
        status: "In Progress",
        schedule: "Fridays 16:00 - 19:00 (Amphitheatre C)",
        materialsCount: 3,
        assignments: [
          { title: "Balanced Scorecard Strategic Implementation Plan", status: "Due 15 Nov", score: "Pending" }
        ],
        overview: "Strategic cost management, Activity-Based Costing (ABC), Balanced Scorecard, and transfer pricing."
      },
      {
        code: "MAF 811",
        title: "Research Methodology",
        units: 3,
        lecturer: "Dr Udeme Eshiet",
        progress: 10,
        grade: "In Progress",
        status: "In Progress",
        schedule: "Thursdays 15:30 - 18:30 (Amphitheatre B)",
        materialsCount: 3,
        assignments: [
          { title: "Master's Thesis Research Proposal", status: "Due 25 Nov", score: "Pending" }
        ],
        overview: "Formulation of research dilemmas, literature review techniques, sampling procedures, and master's thesis architecture."
      }
    ]
  },


  // 2b. MASTER OF ACCOUNTING AND FINANCE (MAF) - CANDIDATE 2
  {
    id: "student-maf-2",
    programmeId: "maf",
    programmeName: "Master of Accounting and Finance (MAF)",
    degreeLevel: "Master's",
    department: "Accounting & Finance",
    fullName: "Blessing Eno Archibong",
    title: "Mrs",
    gender: "Female",
    matricNo: "AKSU/BS/2026/MAF/022",
    email: "blessing.archibong@student.aksu.edu.ng",
    avatar: "https://images.unsplash.com/photo-1567532939604-b6b5b0db2604?q=80&w=300&auto=format&fit=crop",
    supervisor: "Prof. Anthonia Ubom, PhD",
    advisor: "Dr. Mbobo Mbobo, PhD, FCA",
    researchTopic: "Corporate Governance Mechanisms, Audit Committee Attributes and IFRS Compliance in the Nigerian Banking Sector",
    researchStage: "Term 1 Coursework & Methodological Formulation",
    currentTerm: "First Semester (T1), 2026/2027 Session",
    status: "Newly Matriculated • First Semester Commencing",
    cgpa: "Not Computed (First Semester)",
    attendanceRate: 94,
    completedCredits: 0,
    enrolledCredits: 15,
    totalCredits: 36,
    overallProgress: 5,
    curriculumPlan: [
      {
        unit: "T1",
        slot: "Course 1",
        code: "MAF 801",
        course: "MAF 801: Bus. Stats & Data Analytics",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 20,
        lecturer: "Dr Imoh Uford",
        schedule: "Saturdays 08:30 - 11:30 (Amphitheatre C)"
      },
      {
        unit: "T1",
        slot: "Course 2",
        code: "ACC 801",
        course: "ACC 801: Fin.Reporting under IFRS",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 20,
        lecturer: "Dr Mbobo Mbobo",
        schedule: "Saturdays 12:00 - 15:00 (Amphitheatre A)"
      },
      {
        unit: "T1",
        slot: "Course 3",
        code: "FIN 811",
        course: "FIN 811: Corp. Finance & Valuation",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 15,
        lecturer: "Prof. Anthonia Ubom",
        schedule: "Saturdays 15:30 - 18:30 (Amphitheatre A)"
      },
      {
        unit: "T1",
        slot: "Course 4",
        code: "ACC 811",
        course: "ACC 811: Mgmt Accounting & Control",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 15,
        lecturer: "Dr S A Okpo",
        schedule: "Fridays 16:00 - 19:00 (Amphitheatre C)"
      },
      {
        unit: "T1",
        slot: "Course 5",
        code: "MAF 811",
        course: "MAF 811: Research Methodology",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 10,
        lecturer: "Dr Udeme Eshiet",
        schedule: "Thursdays 15:30 - 18:30 (Amphitheatre B)"
      }
    ],
    activeModule: {
      code: "ACC 801",
      title: "Fin.Reporting under IFRS",
      units: 3,
      lecturer: "Dr Mbobo Mbobo",
      progress: 20,
      grade: "Continuous Assessment Active",
      status: "In Progress (Week 2 of 12)",
      schedule: "Saturdays 12:00 - 15:00 (Amphitheatre A & Virtual Studio)",
      materialsCount: 4,
      overview: "Comprehensive analysis of International Financial Reporting Standards (IFRS 9, 15, 16), fair value measurement, financial asset classification, and group consolidated accounts.",
      lessons: [
        {
          id: "acc801-les-1",
          number: "Lesson 1",
          title: "IFRS Regulatory Architecture & Conceptual Framework for Financial Reporting",
          duration: "55 mins",
          status: "Completed",
          completed: true,
          videoTimestamp: 0,
          keyTakeaway: "Qualitative characteristics of financial statements and the IASB conceptual foundation.",
          facilitator: FACULTY_LECTURERS.find(f => f.id === "fac-mbobo")
        },
        {
          id: "acc801-les-2",
          number: "Lesson 2",
          title: "IFRS 9 Financial Instruments: Classification, Measurement & Impairment",
          duration: "65 mins",
          status: "In Progress",
          completed: false,
          current: true,
          videoTimestamp: 25,
          keyTakeaway: "Business model tests, SPPI criteria, and expected credit loss (ECL) 3-stage staging.",
          facilitator: FACULTY_LECTURERS.find(f => f.id === "fac-mbobo")
        }
      ],
      materials: [
        {
          title: "ACC 801 IFRS Executive Master Guide & Financial Reporting Standards",
          type: "Master Guide",
          size: "5.4 MB",
          category: "Course Material"
        },
        {
          title: "IFRS 9 Expected Credit Loss (ECL) Calculation Model in Excel",
          type: "Excel Model",
          size: "6.2 MB",
          category: "Financial Model"
        }
      ],
      assignments: [
        {
          id: "asg-acc801-1",
          title: "IFRS 9 ECL Staging & Banking Portfolio Impairment Study",
          brief: "Model credit loss provisions for commercial loan portfolios using 3-stage transition probabilities.",
          dueDate: "6th November 2026",
          status: "Drafting",
          weight: "30% Continuous Assessment",
          submitted: false
        }
      ]
    },
    modules: [
      { code: "MAF 801", title: "Bus. Stats & Data Analytics", units: 3, lecturer: "Dr Imoh Uford", progress: 20, grade: "In Progress", status: "In Progress", schedule: "Saturdays 08:30 - 11:30", materialsCount: 4, assignments: [], overview: "Financial statistics and analytics." },
      { code: "ACC 801", title: "Fin.Reporting under IFRS", units: 3, lecturer: "Dr Mbobo Mbobo", progress: 20, grade: "In Progress", status: "In Progress", schedule: "Saturdays 12:00 - 15:00", materialsCount: 4, assignments: [], overview: "IFRS accounting and financial reporting." },
      { code: "FIN 811", title: "Corp. Finance & Valuation", units: 3, lecturer: "Prof. Anthonia Ubom", progress: 15, grade: "In Progress", status: "In Progress", schedule: "Saturdays 15:30 - 18:30", materialsCount: 4, assignments: [], overview: "Valuation and corporate finance." },
      { code: "ACC 811", title: "Mgmt Accounting & Control", units: 3, lecturer: "Dr S A Okpo", progress: 15, grade: "In Progress", status: "In Progress", schedule: "Fridays 16:00 - 19:00", materialsCount: 3, assignments: [], overview: "Management control and strategic costing." },
      { code: "MAF 811", title: "Research Methodology", units: 3, lecturer: "Dr Udeme Eshiet", progress: 10, grade: "In Progress", status: "In Progress", schedule: "Thursdays 15:30 - 18:30", materialsCount: 3, assignments: [], overview: "Accounting and finance thesis methodology." }
    ]
  },
  // 3. DOCTOR OF ACCOUNTING AND FINANCE (DAF)
  {
    id: "student-daf",
    programmeId: "daf",
    programmeName: "Doctor of Accounting and Finance (DAF)",
    degreeLevel: "Doctorate",
    department: "Accounting & Finance",
    fullName: "Dr. Clementina Okon",
    title: "Dr",
    gender: "Female",
    matricNo: "AKSU/BS/2026/DAF/003",
    email: "c.okon@student.aksu.edu.ng",
    avatar: "https://images.unsplash.com/photo-1573496799652-408c2ac9fe98?q=80&w=300&auto=format&fit=crop",
    supervisor: "Prof. Joseph Udoayang, PhD, FCA",
    advisor: "Prof. Nkanikpo Ibok, PhD",
    researchTopic: "Positive Accounting Theory, Discretionary Accruals and Capital Allocation Efficiency in the West African Capital Market",
    researchStage: "Stage 1: Doctoral Epistemological Grounding & Econometric Specification",
    currentTerm: "First Semester (T1), 2026/2027 Session",
    status: "Newly Matriculated • Doctoral Research Fellow",
    cgpa: "Not Computed (First Semester)",
    attendanceRate: 100,
    completedCredits: 0,
    enrolledCredits: 15,
    totalCredits: 54,
    overallProgress: 6,
    curriculumPlan: [
      {
        unit: "T1",
        slot: "Course 1",
        code: "DAF 901",
        course: "DAF 901: Philosophy and Foundations of Business research",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 20,
        lecturer: "Prof. Nkanikpo Ibok",
        schedule: "Saturdays 09:00 - 12:00 (Senate Doctoral Amphitheatre)"
      },
      {
        unit: "T1",
        slot: "Course 2",
        code: "DAF 911",
        course: "DAF 911: Adv. Quant. Analysis & Econometrics",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 20,
        lecturer: "Dr Ekere Daniel",
        schedule: "Saturdays 12:30 - 15:30 (Econometric Lab)"
      },
      {
        unit: "T1",
        slot: "Course 3",
        code: "ACC 911",
        course: "ACC 911: Fin.Accounting Theory & research",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 15,
        lecturer: "Prof. Joseph Udoayang",
        schedule: "Fridays 14:00 - 17:00 (Forensic Lab)"
      },
      {
        unit: "T1",
        slot: "Course 4",
        code: "FIN 911",
        course: "FIN 911: Theory of Finance & Asset pricing",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 15,
        lecturer: "Prof. Anthonia Ubom",
        schedule: "Saturdays 15:30 - 18:30 (Capital Markets Suite)"
      },
      {
        unit: "T1",
        slot: "Course 5",
        code: "DAF 941",
        course: "DAF 941: Business writing, publication & research ethics",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 10,
        lecturer: "Dr (Mrs) Eno Ukpong (Ass.Prof)",
        schedule: "Thursdays 15:00 - 18:00 (Writing Studio)"
      }
    ],
    activeModule: {
      code: "DAF 901",
      title: "Philosophy and Foundations of Business research",
      units: 3,
      lecturer: "Prof. Nkanikpo Ibok",
      coLecturer: "Prof. Joseph Udoayang",
      progress: 20,
      grade: "Continuous Assessment Active",
      status: "In Progress (Week 2 of 12)",
      schedule: "Saturdays 09:00 - 12:00 (Senate Doctoral Amphitheatre & Virtual Studio)",
      materialsCount: 4,
      overview: "Philosophical underpinnings of social science and financial accounting research. Epistemological and ontological stances (positivism, interpretivism, critical realism, pragmatism), paradigm debates (Kuhn), and theoretical conceptualization.",
      lessons: [
        {
          id: "daf901-les-1",
          number: "Lesson 1",
          title: "Ontological Paradigms: Realism, Nominalism & Social Reality in Finance",
          duration: "60 mins",
          status: "Completed",
          completed: true,
          videoTimestamp: 0,
          keyTakeaway: "Does financial value exist objectively or is it socially constructed through market perceptions?",
          facilitator: FACULTY_LECTURERS.find(f => f.id === "fac-ibok")
        },
        {
          id: "daf901-les-2",
          number: "Lesson 2",
          title: "Epistemology & Knowledge Validation: Positivism vs Interpretivism",
          duration: "65 mins",
          status: "In Progress",
          completed: false,
          current: true,
          videoTimestamp: 20,
          keyTakeaway: "Hypothetico-deductive testing vs inductive narrative meaning in boardroom governance.",
          facilitator: FACULTY_LECTURERS.find(f => f.id === "fac-ibok")
        },
        {
          id: "daf901-les-3",
          number: "Lesson 3",
          title: "Saunders' Research Onion & Methodological Coherence in DAF Inquiries",
          duration: "55 mins",
          status: "Upcoming",
          completed: false,
          videoTimestamp: 45,
          keyTakeaway: "Aligning philosophy, approach, strategy, choices, time horizons, and empirical procedures.",
          facilitator: FACULTY_LECTURERS.find(f => f.id === "fac-ibok")
        },
        {
          id: "daf901-les-4",
          number: "Lesson 4",
          title: "Paradigm Shifts & Scientific Revolutions: Kuhn and Lakatos Applied to Accounting",
          duration: "50 mins",
          status: "Upcoming",
          completed: false,
          videoTimestamp: 70,
          keyTakeaway: "How positive accounting theory overturned normative accounting doctrine.",
          facilitator: FACULTY_LECTURERS.find(f => f.id === "fac-ibok")
        }
      ],
      materials: [
        {
          title: "DAF 901 Philosophy of Business Research Master Reader (Vol 1)",
          type: "Doctoral Reader",
          size: "4.8 MB",
          category: "Course Reader"
        },
        {
          title: "Saunders Research Onion Master Framework & Analysis Matrix",
          type: "Analysis Matrix",
          size: "2.3 MB",
          category: "Framework"
        }
      ],
      assignments: [
        {
          id: "asg-daf901-1",
          title: "Philosophical Positioning Paper (Doctoral Matrix)",
          brief: "Submit an ontological, epistemological, and axiological positioning matrix for your proposed doctoral research dissertation, comparing how a Positivist versus a Critical Realist would investigate your topic.",
          dueDate: "31st October 2026",
          status: "Drafting (In Progress)",
          weight: "30% Continuous Assessment",
          submitted: false
        }
      ]
    },
    modules: [
      {
        code: "DAF 901",
        title: "Philosophy and Foundations of Business research",
        units: 3,
        lecturer: "Prof. Nkanikpo Ibok",
        progress: 20,
        grade: "In Progress",
        status: "In Progress",
        schedule: "Saturdays 09:00 - 12:00 (Senate Doctoral Amphitheatre)",
        materialsCount: 4,
        assignments: [
          { title: "Philosophical Positioning Paper", status: "Due 31 Oct", score: "Pending" }
        ],
        overview: "Philosophical underpinnings of business and financial accounting inquiry, ontological paradigms, and epistemological justification."
      },
      {
        code: "DAF 911",
        title: "Adv. Quant. Analysis & Econometrics",
        units: 3,
        lecturer: "Dr Ekere Daniel",
        progress: 20,
        grade: "In Progress",
        status: "In Progress",
        schedule: "Saturdays 12:30 - 15:30 (Econometric Lab)",
        materialsCount: 4,
        assignments: [
          { title: "Empirical GARCH Volatility & GMM Estimation", status: "Due 6 Nov", score: "Pending" }
        ],
        overview: "Dynamic panel data models (Arellano-Bond GMM), Vector Autoregression (VAR/VECM), and ARCH/GARCH volatility modeling."
      },
      {
        code: "ACC 911",
        title: "Fin.Accounting Theory & research",
        units: 3,
        lecturer: "Prof. Joseph Udoayang",
        progress: 15,
        grade: "In Progress",
        status: "In Progress",
        schedule: "Fridays 14:00 - 17:00 (Forensic Lab)",
        materialsCount: 4,
        assignments: [
          { title: "Empirical Discretionary Accruals Estimation Paper", status: "Due 15 Nov", score: "Pending" }
        ],
        overview: "Positive Accounting Theory, earnings quality diagnostics, Modified Jones model, and Ohlson value relevance frameworks."
      },
      {
        code: "FIN 911",
        title: "Theory of Finance & Asset pricing",
        units: 3,
        lecturer: "Prof. Anthonia Ubom",
        progress: 15,
        grade: "In Progress",
        status: "In Progress",
        schedule: "Saturdays 15:30 - 18:30 (Capital Markets Suite)",
        materialsCount: 4,
        assignments: [
          { title: "Fama-MacBeth Two-Pass Regression Study", status: "Due 19 Nov", score: "Pending" }
        ],
        overview: "Capital Asset Pricing Model (CAPM), Arbitrage Pricing Theory (APT), and Fama-French multi-factor asset pricing models."
      },
      {
        code: "DAF 941",
        title: "Business writing, publication & research ethics",
        units: 3,
        lecturer: "Dr (Mrs) Eno Ukpong (Ass.Prof)",
        progress: 10,
        grade: "In Progress",
        status: "In Progress",
        schedule: "Thursdays 15:00 - 18:00 (Writing Studio)",
        materialsCount: 4,
        assignments: [
          { title: "Targeted Journal Paper Manuscript Draft", status: "Due 22 Nov", score: "Pending" }
        ],
        overview: "Doctoral publishing excellence in accounting and finance, publication ethics, institutional review boards, and Viva Voce defense."
      }
    ]
  },


  // 3b. DOCTOR OF ACCOUNTING AND FINANCE (DAF) - CANDIDATE 2
  {
    id: "student-daf-2",
    programmeId: "daf",
    programmeName: "Doctor of Accounting and Finance (DAF)",
    degreeLevel: "Doctorate",
    department: "Accounting & Finance",
    fullName: "Kufre Mfoniso James",
    title: "Mr",
    gender: "Male",
    matricNo: "AKSU/BS/2026/DAF/007",
    email: "kufre.james@student.aksu.edu.ng",
    avatar: "https://images.unsplash.com/photo-1522529599102-193c0d76b5b6?q=80&w=300&auto=format&fit=crop",
    supervisor: "Prof. Joseph Udoayang, PhD, FCA",
    advisor: "Dr. Ekere Daniel, PhD",
    researchTopic: "Financial Market Integration, Asset Pricing Anomalies and Macroeconomic Announcements on the Nigerian Exchange Group",
    researchStage: "Stage 1: Doctoral Epistemological Grounding & Econometric Specification",
    currentTerm: "First Semester (T1), 2026/2027 Session",
    status: "Newly Matriculated • Doctoral Research Fellow",
    cgpa: "Not Computed (First Semester)",
    attendanceRate: 98,
    completedCredits: 0,
    enrolledCredits: 15,
    totalCredits: 54,
    overallProgress: 6,
    curriculumPlan: [
      {
        unit: "T1",
        slot: "Course 1",
        code: "DAF 901",
        course: "DAF 901: Philosophy and Foundations of Business research",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 20,
        lecturer: "Prof. Nkanikpo Ibok",
        schedule: "Saturdays 09:00 - 12:00 (Senate Doctoral Amphitheatre)"
      },
      {
        unit: "T1",
        slot: "Course 2",
        code: "DAF 911",
        course: "DAF 911: Adv. Quant. Analysis & Econometrics",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 25,
        lecturer: "Dr Ekere Daniel",
        schedule: "Saturdays 12:30 - 15:30 (Econometric Lab)"
      },
      {
        unit: "T1",
        slot: "Course 3",
        code: "ACC 911",
        course: "ACC 911: Fin.Accounting Theory & research",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 15,
        lecturer: "Prof. Joseph Udoayang",
        schedule: "Fridays 14:00 - 17:00 (Forensic Lab)"
      },
      {
        unit: "T1",
        slot: "Course 4",
        code: "FIN 911",
        course: "FIN 911: Theory of Finance & Asset pricing",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 20,
        lecturer: "Prof. Anthonia Ubom",
        schedule: "Saturdays 15:30 - 18:30 (Capital Markets Suite)"
      },
      {
        unit: "T1",
        slot: "Course 5",
        code: "DAF 941",
        course: "DAF 941: Business writing, publication & research ethics",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 10,
        lecturer: "Dr (Mrs) Eno Ukpong (Ass.Prof)",
        schedule: "Thursdays 15:00 - 18:00 (Writing Studio)"
      }
    ],
    activeModule: {
      code: "FIN 911",
      title: "Theory of Finance & Asset pricing",
      units: 3,
      lecturer: "Prof. Anthonia Ubom",
      progress: 20,
      grade: "Continuous Assessment Active",
      status: "In Progress (Week 2 of 12)",
      schedule: "Saturdays 15:30 - 18:30 (Capital Markets Suite & Virtual Studio)",
      materialsCount: 4,
      overview: "Theoretical architecture of modern finance, stochastic discount factors, multi-factor asset pricing models (CAPM, APT, Fama-French 5-factor), and behavioral finance anomalies.",
      lessons: [
        {
          id: "fin911-les-1",
          number: "Lesson 1",
          title: "Foundations of Financial Asset Valuation & Stochastic Discount Factors",
          duration: "60 mins",
          status: "Completed",
          completed: true,
          videoTimestamp: 0,
          keyTakeaway: "Consumption-based asset pricing models and no-arbitrage conditions.",
          facilitator: FACULTY_LECTURERS.find(f => f.id === "fac-ubom")
        },
        {
          id: "fin911-les-2",
          number: "Lesson 2",
          title: "Cross-Section of Expected Returns: Multi-Factor Models in Frontier Markets",
          duration: "65 mins",
          status: "In Progress",
          completed: false,
          current: true,
          videoTimestamp: 20,
          keyTakeaway: "Size, value, momentum, profitability, and investment factors on the NGX.",
          facilitator: FACULTY_LECTURERS.find(f => f.id === "fac-ubom")
        }
      ],
      materials: [
        {
          title: "FIN 911 Asset Pricing Theory Doctoral Reader & Mathematical Appendix",
          type: "Doctoral Reader",
          size: "4.6 MB",
          category: "Course Material"
        },
        {
          title: "NGX Asset Pricing Factor Models Empirical Stata/R Code Packet",
          type: "Code Packet",
          size: "3.1 MB",
          category: "Empirical Code"
        }
      ],
      assignments: [
        {
          id: "asg-fin911-1",
          title: "Empirical Asset Pricing Multi-Factor Estimation Project",
          brief: "Estimate Fama-MacBeth two-pass regressions for NGX-listed equities over a 10-year monthly horizon.",
          dueDate: "7th November 2026",
          status: "Drafting",
          weight: "30% Continuous Assessment",
          submitted: false
        }
      ]
    },
    modules: [
      { code: "DAF 901", title: "Philosophy and Foundations of Business research", units: 3, lecturer: "Prof. Nkanikpo Ibok", progress: 20, grade: "In Progress", status: "In Progress", schedule: "Saturdays 09:00 - 12:00", materialsCount: 4, assignments: [], overview: "Epistemology and research philosophy." },
      { code: "DAF 911", title: "Adv. Quant. Analysis & Econometrics", units: 3, lecturer: "Dr Ekere Daniel", progress: 25, grade: "In Progress", status: "In Progress", schedule: "Saturdays 12:30 - 15:30", materialsCount: 4, assignments: [], overview: "Advanced econometric modelling." },
      { code: "ACC 911", title: "Fin.Accounting Theory & research", units: 3, lecturer: "Prof. Joseph Udoayang", progress: 15, grade: "In Progress", status: "In Progress", schedule: "Fridays 14:00 - 17:00", materialsCount: 4, assignments: [], overview: "Positive accounting theory." },
      { code: "FIN 911", title: "Theory of Finance & Asset pricing", units: 3, lecturer: "Prof. Anthonia Ubom", progress: 20, grade: "In Progress", status: "In Progress", schedule: "Saturdays 15:30 - 18:30", materialsCount: 4, assignments: [], overview: "Asset pricing and portfolio theory." },
      { code: "DAF 941", title: "Business writing, publication & research ethics", units: 3, lecturer: "Dr (Mrs) Eno Ukpong (Ass.Prof)", progress: 10, grade: "In Progress", status: "In Progress", schedule: "Thursdays 15:00 - 18:00", materialsCount: 4, assignments: [], overview: "Doctoral publishing ethics." }
    ]
  },
  // 4. PhD IN BUSINESS ADMINISTRATION
  {
    id: "student-phd",
    programmeId: "phd-ba",
    programmeName: "Doctor of Philosophy (PhD) in Business Administration",
    degreeLevel: "PhD",
    department: "Business Administration",
    fullName: "Idorenyin Bassey",
    title: "Mrs",
    gender: "Female",
    matricNo: "AKSU/BS/2026/PHD/004",
    email: "i.bassey@student.aksu.edu.ng",
    avatar: "https://images.unsplash.com/photo-1573497019236-17f8177b81e8?q=80&w=300&auto=format&fit=crop",
    supervisor: "Prof. Christabel Brownson, PhD",
    advisor: "Dr. Imoh Uford, PhD",
    researchTopic: "Dynamic Capabilities, Technological Innovation and SME Resilience in the Niger Delta Corridor",
    researchStage: "Stage 1: Doctoral Proposal Formulation & Econometrics",
    currentTerm: "First Semester (T1), 2026/2027 Session",
    status: "Newly Matriculated • Doctoral Research Scholar",
    cgpa: "Not Computed (First Semester)",
    attendanceRate: 100,
    completedCredits: 0,
    enrolledCredits: 9,
    totalCredits: 54,
    overallProgress: 4,
    curriculumPlan: [
      {
        unit: "T1",
        slot: "Course 1",
        code: "BUS 901",
        course: "BUS 901: Data Science and Artificial intelligence",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 20,
        lecturer: "Dr. Imoh Uford",
        schedule: "Saturdays 09:00 - 12:00 (Amphitheatre A)"
      },
      {
        unit: "T1",
        slot: "Course 2",
        code: "BUS 911",
        course: "BUS 911: Adv. Quant. Analysis & Econometrics",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 15,
        lecturer: "Dr Ekere Daniel",
        schedule: "Saturdays 12:30 - 15:30 (Econometric Lab)"
      },
      {
        unit: "T1",
        slot: "Course 3",
        code: "BUS 921",
        course: "BUS 921: Adv. Business Mgmt Theory",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 15,
        lecturer: "Prof. Christabel Brownson",
        schedule: "Fridays 16:00 - 19:00 (Boardroom Suite)"
      }
    ],
    activeModule: {
      code: "BUS 901",
      title: "Data Science and Artificial intelligence",
      units: 3,
      lecturer: "Dr. Imoh Uford",
      progress: 20,
      grade: "Continuous Assessment Active",
      status: "In Progress (Week 2 of 12)",
      schedule: "Saturdays 09:00 - 12:00 (Amphitheatre A)",
      materialsCount: 5,
      overview: "Doctoral big data analytics, machine learning frameworks, predictive analytics, and AI governance in business administration.",
      lessons: [
        {
          id: "phd-les-1",
          number: "Lesson 1",
          title: "Foundations of Big Data & Machine Learning in Business",
          duration: "55 mins",
          status: "Completed",
          completed: true,
          videoTimestamp: 0,
          keyTakeaway: "Tracing computational modeling in organizational strategy.",
          facilitator: FACULTY_LECTURERS.find(f => f.id === "fac-uford")
        }
      ],
      materials: [
        { title: "BUS 901 Study Text & AI Architecture Reader", type: "PDF Document", size: "3.8 MB", category: "Course Reader" }
      ],
      assignments: [
        { id: "asg-phd-1", title: "Empirical AI Strategy Proposal", brief: "Doctoral analytical modeling assignment.", dueDate: "31st October 2026", status: "Drafting", weight: "30%", submitted: false }
      ]
    },
    modules: [
      { code: "BUS 901", title: "Data Science and Artificial intelligence", units: 3, lecturer: "Dr. Imoh Uford", progress: 20, grade: "In Progress", status: "In Progress", schedule: "Saturdays 09:00 - 12:00", materialsCount: 5, assignments: [], overview: "Data science and AI frameworks." }
    ]
  },

  // 5. POSTGRADUATE DIPLOMA (PGD)
  {
    id: "student-pgd",
    programmeId: "pgd-ba",
    programmeName: "Postgraduate Diploma in Business Administration (PGD)",
    degreeLevel: "PGD",
    department: "Business Administration",
    fullName: "Iniobong Akpan",
    title: "Ms",
    gender: "Female",
    matricNo: "AKSU/BS/2026/PGD/142",
    email: "i.akpan@student.aksu.edu.ng",
    avatar: "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?q=80&w=300&auto=format&fit=crop",
    supervisor: "Dr. Imoh Uford, PhD",
    advisor: "Dr Uwem Etim Uwah, PhD, FCA",
    researchTopic: "Inventory Management Systems and Operational Efficiency in Small and Medium Enterprises",
    researchStage: "Term 1 Foundation Courses",
    currentTerm: "First Semester (T1), 2026/2027 Session",
    status: "Newly Matriculated • Term 1 Commencing",
    cgpa: "Not Computed (First Semester)",
    attendanceRate: 100,
    completedCredits: 0,
    enrolledCredits: 6,
    totalCredits: 24,
    overallProgress: 5,
    curriculumPlan: [
      {
        unit: "T1",
        slot: "Course 1",
        code: "BUS 901",
        course: "BUS 901: Foundations of Business Analytics",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 15,
        lecturer: "Dr. Imoh Uford",
        schedule: "Saturdays 09:00 - 12:00 (Hall C-1)"
      },
      {
        unit: "T1",
        slot: "Course 2",
        code: "MAF 801",
        course: "MAF 801: Bus. Stats & Data Analytics",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 10,
        lecturer: "Dr. Imoh Uford",
        schedule: "Saturdays 13:00 - 16:00 (Hall C-1)"
      }
    ],
    activeModule: {
      code: "BUS 901",
      title: "Foundations of Business Analytics",
      units: 3,
      lecturer: "Dr. Imoh Uford",
      progress: 15,
      grade: "Continuous Assessment Active",
      status: "In Progress (Week 2 of 12)",
      schedule: "Saturdays 09:00 - 12:00 (Hall C-1 & Virtual Studio)",
      materialsCount: 4,
      overview: "Principles of corporate data analytics, spreadsheets, and management decision modeling.",
      lessons: [
        {
          id: "pgd-les-1",
          number: "Lesson 1",
          title: "Introduction to Business Analytics & Spreadsheets",
          duration: "40 mins",
          status: "Completed",
          completed: true,
          videoTimestamp: 0,
          keyTakeaway: "Data organization and essential financial functions.",
          facilitator: FACULTY_LECTURERS.find(f => f.id === "fac-uford")
        }
      ],
      materials: [
        { title: "PGD Study Module & Lecture Notes", type: "PDF Document", size: "3.2 MB", category: "Course Material" }
      ],
      assignments: [
        { id: "asg-pgd-1", title: "Spreadsheet Data Modeling Review", brief: "Prepare financial model.", dueDate: "29th October 2026", status: "Drafting", weight: "30%", submitted: false }
      ]
    },
    modules: [
      { code: "BUS 901", title: "Foundations of Business Analytics", units: 3, lecturer: "Dr. Imoh Uford", progress: 15, grade: "In Progress", status: "In Progress", schedule: "Saturdays 09:00 - 12:00", materialsCount: 4, assignments: [], overview: "Business analytics principles." }
    ]
  }
];

// FACULTY DIRECTORY - Includes all 11 Course Lecturers and Acting Director
export const FACULTY_MEMBERS = [
  {
    name: "Dr Uwem Etim Uwah",
    rank: "Acting Director / Associate Professor",
    qualifications: "PhD, FCA, ACTI",
    speciality: "Corporate Financial Reporting, Forensic Accounting & Strategic Auditing",
    email: "uwemuwah@aksu.edu.ng",
    coursesAssigned: ["ACC 911", "Directorate Oversight"],
    avatar: "/director-uwah.png"
  },
  ...FACULTY_LECTURERS.map(fac => ({
    name: fac.name,
    rank: fac.rank,
    qualifications: fac.qualifications,
    speciality: fac.researchInterests.join(", "),
    email: fac.email,
    coursesAssigned: fac.assignedCourses,
    avatar: fac.avatar
  }))
];

// MODULE FACILITATORS DIRECTORY & HELPER
export const MODULE_FACILITATORS = [
  ...FACULTY_LECTURERS.map(fac => ({
    id: fac.id,
    name: fac.formalSalutation,
    rank: fac.rank,
    qualifications: fac.qualifications,
    email: fac.email,
    phone: fac.phone,
    avatar: fac.avatar,
    office: fac.office,
    consultationHours: fac.consultationHours,
    status: "Online • Facilitator in Chambers",
    unreadFeedbackCount: 1,
    assignedCourses: fac.assignedCourses
  })),
  {
    id: "fac-uwah",
    name: "Dr Uwem Etim Uwah, PhD, FCA, ACTI",
    rank: "Acting Director / Associate Professor of Accounting",
    qualifications: "PhD, FCA, ACTI",
    email: "uwemuwah@aksu.edu.ng",
    phone: "+234 803 338 0401",
    avatar: "/director-uwah.png",
    office: "Directorate Suite 1, Executive Wing, Ikot Akpaden",
    consultationHours: "Fridays 10:00 - 13:00",
    status: "Online • Directorate Desk Active",
    unreadFeedbackCount: 2
  }
];

export const getModuleFacilitator = (module, index = 0) => {
  if (module && module.facilitator) return module.facilitator;
  if (module && module.code) {
    const matchedFac = MODULE_FACILITATORS.find(f => f.assignedCourses && f.assignedCourses.includes(module.code));
    if (matchedFac) return matchedFac;
  }
  return MODULE_FACILITATORS[index % MODULE_FACILITATORS.length];
};
// LIVE ADMISSION SCREENING QUEUE (SIMULATION DATA)
export const INITIAL_APPLICANTS = [
  {
    applicationNo: "AKSU-BS-2026-APP-8841",
    fullName: "Obong Victor Okon",
    email: "v.okon@akwaenergy.com",
    phone: "+234 802 443 1120",
    programmeApplied: "Doctor of Business Administration (DBA)",
    category: "Doctoral",
    department: "Business Administration",
    qualifications: "M.Sc Business Administration (UNN, 4.40 CGPA), B.Sc Accounting (Uniuyo, 2:1)",
    workExperience: "14 Years (General Manager, Operations & Compliance at Atlantic Oilfield Logistics)",
    applicationFeePaid: true,
    paystackRef: "PSTK_LIVE_998471203",
    paystackDate: "12 Oct 2026, 14:22",
    documents: [
      { name: "First Degree Certificate (B.Sc)", verified: true },
      { name: "Master's Degree Certificate (M.Sc)", verified: true },
      { name: "Official Academic Transcript", verified: true },
      { name: "Executive CV / Profile", verified: true },
      { name: "Research Intent Statement", verified: true }
    ],
    screeningScore: 92,
    screeningStatus: "Approved", // Approved, Pending, Conditional
    decisionDate: "15 Oct 2026",
    admissionLetterIssued: true,
    matricNo: "AKSU/BS/2026/DBA/019"
  },
  {
    applicationNo: "AKSU-BS-2026-APP-8842",
    fullName: "Blessing Eno Archibong",
    email: "blessing.archibong@firs.gov.ng",
    phone: "+234 803 991 7654",
    programmeApplied: "Executive Master of Accounting and Finance (EMAF)",
    category: "Master's",
    department: "Accounting and Finance",
    qualifications: "B.Sc Banking & Finance (AKSU, First Class Honours, 4.68 CGPA), ACA (In View)",
    workExperience: "6 Years (Senior Tax Auditor, Federal Inland Revenue Service)",
    applicationFeePaid: true,
    paystackRef: "PSTK_LIVE_771923441",
    paystackDate: "14 Oct 2026, 10:15",
    documents: [
      { name: "Degree Certificate (B.Sc First Class)", verified: true },
      { name: "Academic Transcript", verified: true },
      { name: "Employer Sponsorship / Reference", verified: true },
      { name: "Curriculum Vitae", verified: true }
    ],
    screeningScore: 95,
    screeningStatus: "Approved",
    decisionDate: "16 Oct 2026",
    admissionLetterIssued: true,
    matricNo: "AKSU/BS/2026/EMAF/041"
  },
  {
    applicationNo: "AKSU-BS-2026-APP-8843",
    fullName: "Edidiong Sunday Essien",
    email: "e.essien@gov.ak.ng",
    phone: "+234 814 300 8912",
    programmeApplied: "Executive Master of Public Administration (EMPA)",
    category: "Master's",
    department: "Public Administration",
    qualifications: "B.Sc Political Science (Calabar, Second Class Upper)",
    workExperience: "9 Years (Principal Planning Officer, Akwa Ibom State Ministry of Economic Development)",
    applicationFeePaid: true,
    paystackRef: "PSTK_LIVE_665421098",
    paystackDate: "16 Oct 2026, 09:40",
    documents: [
      { name: "Degree Certificate", verified: true },
      { name: "Academic Transcript", verified: false },
      { name: "Government Service Letter", verified: true }
    ],
    screeningScore: 84,
    screeningStatus: "Pending", // Awaiting transcript validation
    decisionDate: "Awaiting Review",
    admissionLetterIssued: false,
    matricNo: null
  },
  {
    applicationNo: "AKSU-BS-2026-APP-8844",
    fullName: "Kufre Mfoniso James",
    email: "kufre.james@gmail.com",
    phone: "+234 703 552 9011",
    programmeApplied: "Postgraduate Diploma in Business Administration (PGD)",
    category: "Postgraduate Diploma",
    department: "Business Administration",
    qualifications: "HND Business Administration (Heritage Polytechnic, Distinction)",
    workExperience: "4 Years (Branch Operations Supervisor, Zenith Bank Plc)",
    applicationFeePaid: true,
    paystackRef: "PSTK_LIVE_441290382",
    paystackDate: "17 Oct 2026, 16:05",
    documents: [
      { name: "HND Certificate (Distinction)", verified: true },
      { name: "Polytechnic Transcript", verified: true },
      { name: "NYSC Discharge Certificate", verified: true }
    ],
    screeningScore: 89,
    screeningStatus: "Approved",
    decisionDate: "18 Oct 2026",
    admissionLetterIssued: true,
    matricNo: "AKSU/BS/2026/PGD/148"
  }
];
